





































import { PartyProductModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import {Component, Vue, Prop, Ref} from 'vue-property-decorator';
import InvestmentDialog from '@/libs/clients/components/InvestmentDialog.vue';

@Component({
    components: {
        InvestmentDialog
    }
})
export default class InvestmentCard extends Vue {


    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialog!: InvestmentDialog;
    
    newId: string | null = Guid.EmptyGuid();

    openPartyProduct() {
        if (this.partyProduct.id == this.newId)
            return;
        this.dialog.open();
    }

}

